/* src/app/components/shared/styles/rdf-table.css */
.table-responsive,
.rdf-table-responsive {
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}
.table-responsive .table,
.rdf-table-responsive .table {
  margin-bottom: 0;
  border-collapse: collapse;
}
.table-responsive .table thead th,
.rdf-table-responsive .table thead th {
  background: var(--gray-50) !important;
  color: var(--fg-3) !important;
  border: none !important;
  border-bottom: 1px solid var(--border) !important;
  font-size: 11px;
  font-weight: var(--weight-semibold);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 11px 14px !important;
  white-space: nowrap;
  -webkit-user-select: none;
  user-select: none;
  transition: background-color var(--dur) var(--ease);
}
.table-responsive .table thead th:hover,
.rdf-table-responsive .table thead th:hover {
  background: var(--gray-100) !important;
}
.table-responsive .table tbody td,
.rdf-table-responsive .table tbody td {
  border-top: 1px solid var(--border) !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: none !important;
  color: var(--fg-2);
  font-size: var(--text-sm);
  padding: 9px 14px !important;
  vertical-align: middle;
}
.table-responsive .table-hover > tbody > tr:hover > td,
.rdf-table-responsive .table-hover > tbody > tr:hover > td {
  background-color: var(--gray-100) !important;
  transition: background-color var(--dur-fast) var(--ease);
}
.table-responsive .selected,
.rdf-table-responsive .selected {
  background-color: var(--navy-100) !important;
  color: var(--navy-700) !important;
}
/*# sourceMappingURL=rdf-table.css.map */
